import { Icon } from '@chakra-ui/react';

const StoreFrontIcon = (props) => (
  <Icon viewBox="0 0 16 16" {...props} fill="none">
    <g id="StoreFrontIcon">
    <path d="M3 8.72501V13C3 13.1326 3.05268 13.2598 3.14645 13.3536C3.24021 13.4473 3.36739 13.5 3.5 13.5H12.5C12.6326 13.5 12.7598 13.4473 12.8536 13.3536C12.9473 13.2598 13 13.1326 13 13V8.72501" stroke="#8D8186" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M3.375 2.5H12.625C12.7335 2.50089 12.8388 2.5366 12.9254 2.60186C13.0121 2.66713 13.0755 2.75849 13.1062 2.8625L14 6H2L2.89375 2.8625C2.92455 2.75849 2.98794 2.66713 3.07458 2.60186C3.16122 2.5366 3.26653 2.50089 3.375 2.5V2.5Z" stroke="#8D8186" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M6 6V7C6 7.53043 5.78929 8.03914 5.41421 8.41421C5.03914 8.78929 4.53043 9 4 9C3.46957 9 2.96086 8.78929 2.58579 8.41421C2.21071 8.03914 2 7.53043 2 7V6" stroke="#8D8186" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M10 6V7C10 7.53043 9.78929 8.03914 9.41421 8.41421C9.03914 8.78929 8.53043 9 8 9C7.46957 9 6.96086 8.78929 6.58579 8.41421C6.21071 8.03914 6 7.53043 6 7V6" stroke="#8D8186" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M14 6V7C14 7.53043 13.7893 8.03914 13.4142 8.41421C13.0391 8.78929 12.5304 9 12 9C11.4696 9 10.9609 8.78929 10.5858 8.41421C10.2107 8.03914 10 7.53043 10 7V6" stroke="#8D8186" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
  </Icon>
);


/**
 *
 * <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">

</svg>
 *
 */

export default StoreFrontIcon;
